import axios from "axios";

// The guest identity cookie is HttpOnly (set by the backend, never read by
// this code) - `withCredentials` is what makes the browser attach and store
// it across requests. The custom header is a lightweight CSRF mitigation
// the backend requires on state-changing requests (see
// backend/app/security/csrf.py); a cross-site request cannot set it.
export const apiClient = axios.create({
    baseURL: import.meta.env.VITE_API_BASE_URL ?? "/api/v1",
    withCredentials: true,
    headers: {
        "X-PDFReader-Client": "web",
    },
});

export interface ApiErrorPayload {
    error_code: string;
    message: string;
}

export function extractApiErrorMessage(error: unknown, fallback: string): string {
    if (axios.isAxiosError(error)) {
        const payload = error.response?.data as ApiErrorPayload | undefined;
        if (payload?.message) return payload.message;
        if (error.code === "ERR_NETWORK") {
            return "Impossibile contattare il server. Controlla la connessione e riprova.";
        }
    }
    return fallback;
}
